module.exports = __webpack_public_path__ + "static/avenir-sample-4cdd0feccfe56b4ce540c37dcfb8eb4f.svg";